import React, { useEffect, useState } from "react";
import { Formik, Form} from "formik";
import { connect } from "react-redux";
import IdpHeader from "./Header";
import { fetchUser } from "../../../store/slices/user/index";
import {getIdpData,getcollegeNonpanData,postIdpData,postImsPush, postClavertap} from '../../../store/slices/idp/index'
import Controler from "./control";
import {EXAMS_DOMAINS} from '../../constants/common'
import Loader from "../common/loader";
import { BsFillCheckCircleFill, BsInfoCircleFill } from "react-icons/bs";
import ButtonLoader from "../common/buttonLoader";
const IdpFormUg = (props) => {  
    const [step, setStep] = useState(null)
    const [isFormSubmit, setIsFormSubmit] = useState(false)
    const [destination, setDestination] = useState(null)
    const [checkedCollegeList, setCheckedCollegeList] = useState([])
    const [examsList, setExamsList] = useState(null)
    const [stateColleges, setStateColleges] = useState(null)
    const [locationList, setLocationList] = useState(null)
    const [panCollegesList, setPanCollegesList] = useState(null)
    const [nonpanCollegesList, setNonpanCollegesList] = useState(null)
    const [formikvalues,setFormikvalues] =useState([])
    const [entity, setEntity] = useState('')
    
    const [initialValues, setInitialValues] = useState({
      colleges_pan: [],
      colleges_non_pan: [],
      users_state_colleges:[],
      locations:[]
    })

    const [clavertap, setClavertap] = useState([])

    const d = new Date();
    const ms = d.getMilliseconds();

    useEffect(() => {
      props.dispatch(fetchUser());
    }, []);
    
    useEffect(()=>{
      if(props.user?.data?.id){
        props.dispatch(getIdpData({uid: props.user?.data?.id, ms:ms}))
      }
      let desti
      if(!!window.location?.search?.includes('destination')) desti = window.location?.search?.replace("?destination=", "");
      else desti = 'https://www.careers360.com'
      setDestination(desti);

    },[props.user])

    const gotToHomePage = window.location?.origin;
    useEffect(() => {
      if (!!props?.isUser?.user_error && !!destination)
        window.location.href = destination;
      else if (!!props?.isUser?.user_error && !destination)
        window.location.href = gotToHomePage;
      else if (!!props?.isUser?.user && !destination)
        window.location.href = gotToHomePage;
    }, [props?.isUser]);

    const sortedFeaturedData = (data)=>{
      let featured = []
      let non_featured = []
      data?.forEach(obj => {
        obj.featured == true ? featured.push(obj) : non_featured.push(obj) 
      })
      return [...featured, ...non_featured]
    }

    useEffect(()=>{
      if(!!destination && (props.idpData?.admission_preference_status == 2)){
        window.location.href =  destination
      }
      if(props.idpData?.idp?.length){
          setNonpanCollegesList(null)
          setPanCollegesList(null)
          let domain = EXAMS_DOMAINS.find(item=> item.id == props.idpData?.education_stream)
          props.getDomain(domain?.value || '')
          let entity_list = ['exams','state_exams', 'users_state_colleges', 'colleges_pan','locations']
          var entity_values = [];
          let new_exams = []
          for(let item of props.idpData?.idp){
            if(entity_list.includes(item.entity)){
              if(item.entity === 'locations'){
                entity_values[item.entity] = item.value
              } else {
                if(['exams','state_exams'].includes(item.entity)){
                  new_exams = [...new_exams, ...item.value]
                } else {
                  entity_values[item.entity] = item.value?.filter(item => item.selected == false)
                }
              }
            }
          } 
          entity_values['exams'] = new_exams?.filter(item => item.selected == false)
          
          !!entity_values?.exams?.length && setExamsList(sortedFeaturedData(entity_values?.exams))
          !!entity_values?.users_state_colleges?.length && setStateColleges(sortedFeaturedData(entity_values?.users_state_colleges)) 
          !!entity_values.colleges_pan?.length && setPanCollegesList(sortedFeaturedData(entity_values.colleges_pan))
          setLocationList(entity_values.locations)
          if(!!entity_values?.exams?.length){
            setStep(props.idpData?.admission_preference_status)
          }else{
            setStep(1);
          }
      }
    },[props.idpData])
    
    useEffect(()=>{
      setNonpanCollegesList([])
      !!props.collegeNonpanData?.length && setNonpanCollegesList(sortedFeaturedData(props.collegeNonpanData))
    },[props.collegeNonpanData])
    
    useEffect(()=>{
      if(step && !!locationList?.length){
        let locationIDs = []
        for(let obj of locationList){
          obj.selected == 1 && locationIDs.push(`${obj.id}`)
        }
        
        setInitialValues({
          ...initialValues,
          colleges_pan: formikvalues?.colleges_pan || [],
          locations: locationIDs
        })

        if(!!locationIDs?.length){
          let loc_ids = locationIDs?.toString()
          props.dispatch(getcollegeNonpanData({
            uid: props.user?.data?.id,
            idp_form_id:props.engineeringFormData?.idp_form_id,
            loc_ids,
            ms,
          }))
        }
      }
    },[locationList])

    const [isDisabled, setIsDisabled] = useState({college_pan:false,college_non_pan:false, location:false})
    useEffect(()=>{
      let exams = formikvalues?.exams?.length >=6?true:false
      let locations = formikvalues?.locations?.length >=4?true:false
      if(checkedCollegeList?.length <= 8 ){
        let college_pan
        let users_state_colleges = (formikvalues?.users_state_colleges?.length + formikvalues?.colleges_pan?.length) == 8 || formikvalues?.users_state_colleges?.length >= 7 ? true : false
        
        if(!!locationList?.length){
          college_pan = (formikvalues?.colleges_non_pan?.length + formikvalues?.colleges_pan?.length) == 8 || formikvalues?.colleges_pan?.length >= 7 ? true : false
        } else if (!!stateColleges?.length){
          college_pan = (formikvalues?.users_state_colleges?.length + formikvalues?.colleges_pan?.length) == 8 || formikvalues?.colleges_pan?.length >= 7 ? true : false
        }else {
          college_pan = formikvalues?.colleges_pan?.length >= 8 ? true : false
        }
        let college_non_pan = (formikvalues?.colleges_non_pan?.length + formikvalues?.colleges_pan?.length) == 8 || formikvalues?.colleges_non_pan?.length >= 7 ? true : false
        setIsDisabled({
          locations,
          college_pan,
          college_non_pan,
          exams,
          users_state_colleges
        })
      }
      if(entity == 'locations'){
        let loc_ids = formikvalues?.locations?.toString()
        props.dispatch(getcollegeNonpanData({
          uid: props.user?.data?.id,
          idp_form_id:props.engineeringFormData?.idp_form_id,
          loc_ids,
          ms,
        }))
      }
      
    },[formikvalues])

    useEffect(()=>{
      let element = document.querySelector('.progressDiv')
      step ==0 && !!formikvalues?.exams?.length ? element.classList.add('step_1'):element.classList.remove('step_1')
      step == 1 ? element.classList.add('step_2'):element.classList.remove('step_2')
      !!formikvalues?.colleges_pan?.length ? element.classList.add('step_3'):element.classList.remove('step_3')
    },[step, formikvalues])
    
    const onSubmit= () =>{
      let adm_status = step == 0 ? 1 : 2
      adm_status == 2 && setIsFormSubmit(true)
      let postData = {
        uid: props.user?.data?.id,
        online_college_preference: '',
        idp_type: props.idpData?.idp_type,
        idp_form_id: props.idpData?.idp_form_id,
        admission_preference_status: adm_status,
      }
      props.dispatch(postIdpData(postData));
    }
    
    const handleChange = (e,type, obj) =>{
      let {value, name} = e.target
      name === 'users_state_colleges' && (name = 'colleges_non_pan')
      setEntity(name)
      if(type !== 'ims_push'){
        let postData = {
          uid: props.user?.data?.id,
          online_college_preference: '',
          idp_type: props.idpData?.idp_type,
          idp_form_id: props.idpData?.idp_form_id,
        }
        e.target.checked ? postData[name] = [value] : postData['unselected_'+name] = [value]
        props.dispatch(postIdpData(postData))
      } else if(type == 'ims_push' && e.target.checked) {
        props.dispatch(postImsPush({
          uid:props.user?.data?.id,
          exam_id:[],
          coaching_id:10000000
        }));
      }
      
      if(['colleges_non_pan','colleges_pan'].includes(type)){
        if(e.target.checked){
          let newObj =  {
            uid:props.user?.data?.id,
            Category: "college",
            Id: obj?.id,
            name: obj?.name,
            application_link: obj.application_link,
            caption: obj.caption_2,
            logo: obj?.form_logo,
            selected:1
          }
          setClavertap(prev => [...prev, newObj])
        } else {
          setClavertap(prev => {
            let data = prev?.filter(item=> item.Id !== obj.id)
            return data
          })
        }
      }
    }
   
    const validate = (values) =>{
      setCheckedCollegeList([...values?.colleges_pan, ...values?.colleges_non_pan, ...values?.users_state_colleges])
      let error = {}
      if(!values?.exams?.length && step == 0) error.exams = 'This Field is required'
      if(!!locationList?.length && !values?.locations?.length) error.locations = 'This Field is required'
      if(!!stateColleges?.length && !values?.users_state_colleges?.length) error.users_state_colleges = 'This Field is required'
      if(!values?.colleges_pan?.length) error.colleges_pan = 'This Field is required'
      if(!!nonpanCollegesList?.length && !values?.colleges_non_pan?.length) error.colleges_non_pan = 'This Field is required'
      return error
    }
    

    useEffect(()=>{
      if(props.postRequest?.admission_preference_status){
        setStep(props.postRequest?.admission_preference_status)
        if(props.postRequest?.admission_preference_status ==  2) window.location.href =  destination
      }
    },[props.postRequest])

    useEffect(()=>{
      const differenceArray = []
      let {origin} = window.location
      panCollegesList?.filter(obj1 => {
        if(!clavertap?.some(obj2 => obj1.id === obj2.Id)){
          differenceArray.push({
              uid:props.user?.data?.id,
              Category: "college",
              Id: obj1?.id,
              name: obj1?.name,
              application_link:`${origin}/api/ad-emailer-activity-buddy?uid=${props.user?.data?.id}&cid=${obj1?.campaign_id}&clg_id=${obj1?.id}&encryption=1`,
              caption: obj1?.caption_2,
              logo: obj1?.form_logo,
              selected: 0
          })
        }
      });

      let pushData = {
        uid:props.user?.data?.id,
        event_name:'Charged',
        event_data:{
          idp_type:'idp',
          Items: [...clavertap,...differenceArray]
        }
      }
      
      const handleBeforeUnload = (e) => {
        e.preventDefault();
        props.dispatch(postClavertap(pushData))
      };
      
      window.addEventListener('pagehide', handleBeforeUnload);
      
      return () => {
        window.removeEventListener('pagehide', handleBeforeUnload);
        
      };
    },[clavertap, panCollegesList])
    
    return (<>
        <IdpHeader classToggle={!!examsList?.length?'':'removed_stepper'} isLocation={!!locationList?.length} preferenceStatus={step} />
        {!props.idpData?.idp?.length || step == 2 ? <Loader /> :
        <Formik 
          initialValues={initialValues}
          validateOnMount = {true}
          validate={validate} 
          enableReinitialize={true} 
          onSubmit={onSubmit}
        >
          {({values, isValid})=>{
            setTimeout(()=>{
              setFormikvalues(values)
            },10)
          return (
            <Form>
              <div className="ug_pg_common_container">  
                <div className="idp_container_inner">  
                  {(!!examsList?.length && step == 0) &&<>
                    { formikvalues?.exams?.length >=1 &&
                      <div className="exams_error">You have selected {formikvalues?.exams?.length} exams.</div>
                    }
                    <div className="idp_card idp_card_exam">
                      <Controler control="checkbox" max={isDisabled?.exams} handleChange={handleChange} options={examsList} name="exams" questionName="" />
                    </div>
                    
                    <div className="ug_pg_blk">
                        <button className="submit_btn"
                        disabled={!values?.exams?.length}
                        onClick={onSubmit}
                        type="submit">Next</button>
                    </div>
                  </>}
                  
                  {(!!locationList?.length && step == 1) &&
                    <div className="idp_card location_card">
                      <p className="question_breif">Preferred states (select up to 4)</p>
                      {values?.locations?.length >= 4 &&
                      <div className="college_limit_counter"><BsFillCheckCircleFill/> You can select only upto 4 States</div>}
                      <Controler control="checkbox"  max={isDisabled?.locations}  handleChange={handleChange} options={locationList} name="locations" questionName="" />
                    </div>
                  }


                  {(!!panCollegesList?.length || !!nonpanCollegesList?.length) && step == 1 &&
                    <div className="idp_card">
                      
                      {checkedCollegeList?.length >= 8 &&
                        <div className="college_limit_counter"><BsFillCheckCircleFill/> You can select only upto 8 colleges</div>
                      }
                      {!!stateColleges?.length &&<>
                        <h3 className="card_sub_heading">We have curated a list of colleges based on your location. Please select up to 4 colleges.</h3>
                        <div className="info_blk">The <BsInfoCircleFill/> button will give you detailed information about the college.</div>
                        {formikvalues?.users_state_colleges?.length == 7 && formikvalues?.colleges_pan?.length == 0 &&
                          <div className="college_limit_error"><BsFillCheckCircleFill/> You have to select at least 1 College from the National Level Colleges/Universities.
                          </div>
                        }
                        <Controler control="checkbox" max={isDisabled?.users_state_colleges}  handleChange={handleChange} formikValues={formikvalues?.users_state_colleges} options={stateColleges} name="users_state_colleges" questionName="" />
                      </>}

                      {!!panCollegesList?.length &&<>
                        <h3 className="card_sub_heading">We have curated a list of colleges that accept admissions on a National Level. Please select up to 4 colleges.</h3>
                        <div className="info_blk">The <BsInfoCircleFill/> button will give you detailed information about the college.</div>
                        {(!!locationList?.length || !!stateColleges?.length) && formikvalues?.colleges_pan?.length == 7 && (formikvalues?.colleges_non_pan?.length || formikvalues?.users_state_colleges?.length) == 0 &&
                          <div className="college_limit_error"><BsFillCheckCircleFill/> You have to select at least 1 College based on your {!!stateColleges?.length?'state level':'location'} preferences.</div>
                        }
                        <Controler control="checkbox" checkedCollegeList={checkedCollegeList}  max={isDisabled?.college_pan}  handleChange={handleChange} formikValues={formikvalues?.college_pan} options={panCollegesList} name="colleges_pan" questionName="" />
                      </>}

                      {(!!nonpanCollegesList?.length && step == 1) &&<>
                        <br/>
                        <h3 className="card_sub_heading">We have curated a list of colleges based on your preferred location(s). Please select up to 4 colleges.</h3>
                        <div className="info_blk">The <BsInfoCircleFill/> button will give you detailed information about the college.</div>
                        {formikvalues?.colleges_non_pan?.length == 7 && formikvalues?.colleges_pan?.length == 0 &&
                          <div className="college_limit_error"><BsFillCheckCircleFill/> You have to select at least 1 College from the National Level Colleges/Universities.
                          </div>
                        }
                        <Controler control="checkbox" checkedCollegeList={checkedCollegeList} max={isDisabled?.college_non_pan} handleChange={handleChange} formikValues={formikvalues?.college_non_pan} options={nonpanCollegesList} name="colleges_non_pan" questionName="" />
                      </>}  
                    </div>
                  }

                  {step == 1 && <>
                    <div className="idp_card single_checkbox">
                      <input type="checkbox" onChange={(e)=> handleChange(e, 'ims_push')} id="single_check"/>
                      <label htmlFor="single_check">I want to subscribe to the premium information service (Starting at Rs.499 per year) to:</label>
                    </div>
                    <div className="ug_pg_blk">
                      {isFormSubmit ? <ButtonLoader/>:
                        <button className="submit_btn"
                        disabled={isValid == false}
                        type="submit">Submit your preferences</button>
                      }
                    </div>
                  </>}
                </div>
              </div>
          </Form>
          )}}
        </Formik>
        }
    </>)
};

const mapStateToProps = (state) => {
  return {
    user: state.userData?.user,
    isUser: state.userData,
    idpData: state.idp?.getIdpSuccess?.data,
    collegeNonpanData: state.idp?.getNonpanCollegesSuccess?.data,
    postRequest:state.idp?.postIdpSuccess?.data
  };
};  

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IdpFormUg);